import { render, staticRenderFns } from "./iordanidhs.vue?vue&type=template&id=66807660"
import script from "./iordanidhs.vue?vue&type=script&lang=js"
export * from "./iordanidhs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports